var _style, _defs, _rect, _defs2, _rect2, _defs3, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoTsPayAzzurro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 24",
    style: {
      enableBackground: "new 0 0 56 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);fill:#0090D1;}\n\t.st1{clip-path:url(#SVGID_4_);fill:#0090D1;}\n\t.st2{clip-path:url(#SVGID_6_);fill:#0090D1;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 14") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M2.9,18.9c0,0,0.1,0.2,0.3,0.5c0.1,0.2,0.2,0.3,0.2,0.3l0,0c1.1,1.4,2.9,2.4,5,2.7c0,0,4.1-0.9,5.4-3.5 C13.5,19,13,19,12.6,19c-1.8,0-2.6-0.8-3-2c0,0,0,0,0,0c0-0.1,0-0.1-0.1-0.2c0-0.1-0.1-0.3-0.1-0.4c0,0,0,0,0,0 c-0.1-0.5-0.1-1-0.1-1.5v-2v-0.3v-0.3V8.4V8v0h0.2h1.8V4.4h-2V1.7H8c-3.9,0-5.9,1.5-5.9,4.8v0.3v0.4v0.5v5.2V13v0.4v2.2 C2.1,16.9,2.4,18,2.9,18.9L2.9,18.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -2.9,
    y: -3.3,
    className: "st0",
    width: 21.7,
    height: 30.7
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M10.9,22.6l0.1,0.3c0.2,0,0.9,0,2.3,0c3,0,6.4-0.7,8.1-2.7l0,0c0,0,0.2-0.2,0.3-0.4 c0.1-0.2,0.2-0.3,0.2-0.3l0,0c0.5-0.7,0.7-1.6,0.7-2.7c0-0.8-0.3-2.3-0.5-3.6h0c0,0,0-0.1-0.1-0.3c0,0,0,0,0,0c0,0,0,0,0,0 c0-0.1,0-0.2-0.1-0.3h0c-0.2-1.1-0.4-1.9-0.5-2.2c0-0.3-0.1-0.6,0-0.9c0,0,0,0,0,0c0-0.1,0-0.2,0-0.2c0.2-0.9,1-1.2,2.2-1.2V4.6 h-4.7c-2,0-3.6,0.9-4.3,2.3l0,0c0,0,0,0.1-0.1,0.2c0,0,0,0,0,0.1c0,0.1-0.1,0.2-0.1,0.3C14.5,7.7,14.4,8,14.4,8l0,0 c-0.1,0.6-0.1,1.3,0,2c0.3,1.5,0.7,2.7,0.9,3.9c0.2,0.9,0.3,1.9,0.3,3c0,0.4,0,0.8-0.1,1.1C15.2,20,13.7,21.6,10.9,22.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.9,
    y: -0.4,
    className: "st1",
    width: 22.8,
    height: 28.3
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M49,21c2.2,0,2.6-1.2,3.5-3.6l2.8-8.1h-2.1l-1.9,6.2l-1.7-6.2h-2.2l2.9,8.7l-0.1,0.2 c-0.3,1-0.8,1.2-1.4,1.2c-0.4,0-0.8-0.1-1.1-0.1l-0.2,1.5C48,20.9,48.5,21,49,21z M42.2,16.3c-0.8,0-1.2-0.3-1.2-0.9 c0-0.9,0.8-1.2,1.9-1.2c0.4,0,0.8,0,1,0.1v0.2C44,15.3,43.3,16.3,42.2,16.3z M41.5,17.9c1.2,0,2-0.4,2.7-1.3l0.2,1.1h1.7v-5.5 c0-2.2-1.2-3.1-3.3-3.1c-1.3,0-2.5,0.5-3.4,1.2l0.7,1.3c0.8-0.5,1.5-0.8,2.5-0.8c0.9,0,1.4,0.4,1.4,1.4v0.6 c-0.4,0-0.7-0.1-1.2-0.1c-2.9,0-3.9,1.3-3.9,2.7C38.9,17.1,40,17.9,41.5,17.9z M33.6,11.9h-1.7V8.1h1.8c1.4,0,2,0.7,2,1.9 S35.1,11.9,33.6,11.9z M31.9,17.7v-4h1.8c2.9,0,4.2-1.5,4.2-3.8c0-2.3-1.4-3.7-4.1-3.7h-4.2v11.5H31.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.7,
    y: 1.2,
    className: "st2",
    width: 35.6,
    height: 24.8
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTsPayAzzurro);
export default __webpack_public_path__ + "static/media/logo-ts-pay_azzurro.295f1c3bff56b1bf89d32967c9965cd0.svg";
export { ForwardRef as ReactComponent };